import { render, staticRenderFns } from "./levelLayout.vue?vue&type=template&id=95b64e7c"
import script from "./levelLayout.vue?vue&type=script&lang=js"
export * from "./levelLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2beaf340b9398788f22b022855d419b1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports